var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_922_333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1015,
    y: -714,
    width: 1440,
    height: 2500,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_922_333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -714,
    y: -205.858,
    width: 1111,
    height: 1772.56,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0009 27.7999L12.9273 23.5999C11.9697 22.8341 12.3897 21.2941 13.6049 21.1205L20.8009 20.7999L23.8739 13.0957C24.0881 12.6687 24.5235 12.3999 25.0009 12.3999C25.4783 12.3999 25.9137 12.6701 26.1279 13.0957L29.2009 20.7999L36.3969 21.1205C37.6121 21.2941 38.0321 22.8341 37.0745 23.5999L32.0009 27.7999L33.3855 35.9997C33.5451 37.1183 32.3831 37.9555 31.3737 37.4501L25.0009 33.3999L18.6281 37.4487C17.6173 37.9541 16.4567 37.1169 16.6163 35.9983L18.0009 27.7999Z",
    fill: "#E7E7E7"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1014.5,
    y: -713.5,
    width: 1439,
    height: 2499,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_922_333",
    x: -762,
    y: -251.858,
    width: 1207,
    height: 1868.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_922_333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_922_333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_922_333"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1015,
    y: -714,
    width: 1440,
    height: 2500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/emptyStar.ad8949981bfbd03dbe08168616174596.svg";
export { ForwardRef as ReactComponent };